module.exports = __webpack_public_path__ + "static/gradientOne-d3abd47c590b5f694043c47cfe81eca9.png";